import React from 'react'



const Register = () => {
  return (
    <div className='animation-bg'>
      <header >
        Hello
      </header>
      <div>
        <div className="wave"></div>
        <div className="wave"></div>
        <div className="wave"></div>
      </div>
    </div>
  )
}

export default Register